import ServiceFeatureCard from './ServiceFeatureCard';

export default ServiceFeatureCard;
